import {
  LOGIN_WITH_TOKEN_KEY,
  LOGIN_WITH_TOKEN_KEY_SUCCESS,
  LOGIN_WITH_TOKEN_KEY_FAIL,
  REGISTER_GUEST_TO_EVENT,
  REGISTER_GUEST_TO_EVENT_SUCCESS,
  REGISTER_GUEST_TO_EVENT_FAIL,
} from "./actionType";

//LOGIN_WITH_TOKEN_KEY
export const loginWithTokenKey = (data, token) => ({
  type: LOGIN_WITH_TOKEN_KEY,
  data,
  token,
});
export const loginWithTokenKeySuccess = (payload) => ({
  type: LOGIN_WITH_TOKEN_KEY_SUCCESS,
  payload,
});
export const loginWithTokenKeyFail = (payload) => ({
  type: LOGIN_WITH_TOKEN_KEY_FAIL,
  payload,
});

//REGISTER_GUEST_TO_EVENT
export const registerGuestToEvent = (data, token) => ({
  type: REGISTER_GUEST_TO_EVENT,
  data,
  token,
});
export const registerGuestToEventSuccess = (payload) => ({
  type: REGISTER_GUEST_TO_EVENT_SUCCESS,
  payload,
});
export const registerGuestToEventFail = (payload) => ({
  type: REGISTER_GUEST_TO_EVENT_FAIL,
  payload,
});
